import React, { InputHTMLAttributes } from 'react';
import { applyComponentTheme } from '../../../theme';
import InputUnderline from '../InputUnderline';
import { InputComponent } from '../inputTypes';
import { Container, InputCharacterCount, StyledTextAreaInput } from './styles';

export type TextAreaInputProps = {
  id: string;
  value?: string;
  showCharacterCount?: boolean;
} & InputHTMLAttributes<HTMLTextAreaElement>;

const TextAreaInput: InputComponent<TextAreaInputProps> = ({
  className,
  value,
  showCharacterCount,
  ...rest
}) => {
  const characterCount = `${value ? value.length : 0}/${rest.maxLength}`;
  return (
    <>
      <Container className={className}>
        <StyledTextAreaInput type="text" value={value} {...rest} />
        <InputUnderline />
      </Container>
      {showCharacterCount && rest.maxLength && (
        <InputCharacterCount aria-label={`Character count: ${characterCount}`}>
          {characterCount}
        </InputCharacterCount>
      )}
    </>
  );
};

export default applyComponentTheme(TextAreaInput, 'TextAreaInput');
